import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';
import bgPopup from '../../assets/images/perfect_match/bg_popupUp.png';

const useResultStyles = createUseStyles((theme: Theme) => {
    return {
        container: {
            width: '100%',
            minHeight: '100vh',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
        },
        backgroundImage: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
        },
        breweryImage: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
        },
        contentOverlay: {
            position: 'relative',
            zIndex: 1,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        },
        headerSection: {
            position: 'absolute',
            top: '0.1rem',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.5rem',
            zIndex: 3,
        },
        logoImage: {
            width: 'auto',
            height: 'clamp(150px, 15vh, 180px)',
            objectFit: 'contain',
        },
        resultSection: {
            position: 'relative',
            width: 'clamp(75%, 70vw, 85%)',
            minHeight: 'clamp(65%, 55vh, 70%)',
            maxWidth: '1100px',
            padding: 'clamp(1.5rem, 2.5vh, 2.5rem) clamp(3rem, 5vw, 5rem)',
            backgroundImage: `url(${bgPopup})`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'clamp(0.5rem, 1vh, 1rem)',
            zIndex: 2,
            marginTop: 'clamp(2.5rem, 4vh, 4rem)',
        },
        resultTitle: {
            fontFamily: theme.fonts.poplar,
            fontSize: 'clamp(1.4rem, 1.8vw, 1.8rem)',
            fontWeight: 500,
            color: theme.colors.golden_mustard,
            textAlign: 'center',
            letterSpacing: 'clamp(0.1rem, 0.2vw, 0.15rem)',
            lineHeight: 1.3,
            marginBottom: '0.3rem',
            marginTop: '2.5rem',
        },
        resultText: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1rem, 1.2vw, 1.3rem)',
            fontWeight: 400,
            color: theme.colors.ivory_beige,
            textAlign: 'center',
            letterSpacing: '0.05rem',
            lineHeight: 1.5,
            marginBottom: '0.3rem',
            padding: '0 1.5rem',
        },
        codeContainer: {
            backgroundColor: 'black',
            borderRadius: '8px',
            padding: 'clamp(0.6rem, 1vh, 1rem) clamp(1rem, 1.5vw, 1.5rem)',
            marginTop: '0.3rem',
            width: '50%',
            maxWidth: '300px',
            border: `2px solid ${theme.colors.ivory_beige}`,
        },
        codeLabel: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(0.75rem, 1vw, 0.9rem)',
            fontWeight: 600,
            color: theme.colors.ivory_beige,
            textAlign: 'center',
            marginBottom: '0.3rem',
        },
        codeValue: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1.2rem, 2vw, 1.8rem)',
            fontWeight: 700,
            color: theme.colors.ivory_beige,
            textAlign: 'center',
            letterSpacing: 'clamp(0.3rem, 0.5vw, 0.4rem)',
        },
        saveCodeText: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(0.7rem, 0.95vw, 0.8rem)',
            fontStyle: 'italic',
            color: theme.colors.ivory_beige,
            textAlign: 'center',
            marginTop: '0.3rem',
            marginBottom: '0.3rem',
        },
        finalizeButton: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1rem, 1.4vw, 1.2rem)',
            fontWeight: 700,
            backgroundColor: theme.colors.ivory_beige,
            color: theme.colors.espresso_brown,
            padding: 'clamp(1rem, 1vh, 1.2rem) clamp(2rem, 3vw, 3rem)',
            border: `3px solid ${theme.colors.espresso_brown}`,
            borderRadius: '8px',
            cursor: 'pointer',
            textTransform: 'uppercase',
            letterSpacing: '0.1rem',
            marginTop: '-0.75rem',
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: theme.colors.espresso_brown,
                color: theme.colors.ivory_beige,
                border: `3px solid ${theme.colors.ivory_beige}`,
                transform: 'scale(1.05)',
            },
        },
        charactersSection: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            padding: '0 clamp(2rem, 4vw, 4rem)',
            pointerEvents: 'none',
            zIndex: 3,
        },
        characterLeft: {
            height: 'clamp(35vh, 42vh, 45vh)',
            width: 'auto',
            objectFit: 'contain',
            objectPosition: 'bottom left',
            transform: 'translateX(clamp(-3rem, -5vw, -5rem))',
        },
        characterCenter: {
            height: 'clamp(28vh, 32vh, 35vh)',
            width: 'auto',
            objectFit: 'contain',
            objectPosition: 'bottom center',
        },
        characterRight: {
            height: 'clamp(35vh, 42vh, 45vh)',
            width: 'auto',
            objectFit: 'contain',
            objectPosition: 'bottom right',
            transform: 'translateX(clamp(3rem, 5vw, 5rem))',
        },
        promoalcool: {
            position: 'absolute',
            bottom: '5.5rem',
            right: '9.5rem',
            width: '200px',
            height: 'auto',
            objectFit: 'contain',
            zIndex: 10,
        },
    };
});

export default useResultStyles;